import { emptyLogSheet } from "../log-sheet/log-sheet-form/empty-log-sheet";
import { fetchLogSheets } from "../log-sheet/fetch-log-sheets";
import { HistoryLogSheetCellsInfoArray } from "../log-sheet/log-sheet-history/HistoryLogSheetCellsInfoArray";
import { ImportHistoryOfLogSheet } from "../log-sheet/log-sheet-history/ImportHistoryOfLogSheet";
import { CreateLogSheetChange } from "../log-sheet/log-sheet-form/CreateLogSheetChange";
import {
  AttachmentDocs,
  LogSheetTableMeta,
  LogSheetTableEquipmentCentricMeta,
  configurationDetailsField
} from "../log-sheet/log-sheet-table/LogSheetTableMeta";
import { logSheetValidationSchemaFactory } from "../log-sheet/log-sheet-form/log-sheet-validation-schema";
import { makeCleanLogSheet } from "../log-sheet/log-sheet-form/make-clean-log-sheet";
import { logSheetItemsToSheet, runSheetItemsToPDF } from "../log-sheet/log-sheet-export/log-sheet-items-to-sheet";
import { logSheetSelectSuggestion } from "../log-sheet/log-sheet-form/log-sheet-select-suggestion";
import { logSheetClearSuggestion } from "../log-sheet/log-sheet-form/log-sheet-clear-suggestion";
import ItemPage from "./ItemPage";
import { Attachments } from "../common-for-log-sheet-and-run-logs/HistoryCommonCellsInfo";
import ActionDataInputsBox from "../log-sheet/log-sheet-form/ActionDataInputsBox";
import LOGBOOK_LABEL from "./../../../utils/constants/logbookLabel";
import { entryType, formTypes, LOG_TYPES, LOGBOOK_ATTACHMENTS } from "../../../constants";
import { useParams } from "react-router-dom";
import ACTION_LOGS_DATA_MODEL from "../../../utils/constants/actionLogsDataModel";
import { isData4eye } from "@digitallab/grid-common-frontend-components";
import { equipmentStatus } from "../../../constants";

const LogSheetPage = ({ equipmentDetail }) => {
  const { inventoryId } = useParams();
  if (
    !LogSheetTableMeta.expandedComponentProps.infoMeta.fields.some(
      (el) => el.lookapVal === LOGBOOK_ATTACHMENTS.ATTACHMENTS
    )
  ) {
    LogSheetTableMeta.expandedComponentProps.infoMeta.fields.push(AttachmentDocs);
  }

  if (!HistoryLogSheetCellsInfoArray.some((el) => el.label === Attachments.label)) {
    HistoryLogSheetCellsInfoArray.push(Attachments);
  }

  if (
    !LogSheetTableEquipmentCentricMeta.expandedComponentProps.infoMeta.fields.some(
      (el) => el.lookapVal === LOGBOOK_ATTACHMENTS.ATTACHMENTS
    )
  ) {
    LogSheetTableEquipmentCentricMeta.expandedComponentProps.infoMeta.fields.push(AttachmentDocs);
  }

  if (
    equipmentDetail?.entryType !== entryType.cluster &&
    !LogSheetTableEquipmentCentricMeta.expandedComponentProps.infoMeta.fields.some(
      (el) => el.label === ACTION_LOGS_DATA_MODEL.configurationDetails.value
    )
  ) {
    LogSheetTableEquipmentCentricMeta.expandedComponentProps.infoMeta.fields.push(configurationDetailsField);
  }

  const defaultValues = {
    qualificationStatus: equipmentDetail?.gxpReady?.newValue?.value,
    systemStatus: equipmentDetail?.systemStatus?.newValue?.key,
    softwareVersion: equipmentDetail?.updatedSoftwareVersion?.newValue,
    configurationBaseline: equipmentDetail?.logbookConfigurationBaseline?.newValue,
    configurationDetails: equipmentDetail?.logbookConfigurationDetails?.newValue
  }

  const isPropagationDisabled = equipmentDetail && isData4eye(equipmentDetail) && equipmentDetail.status === equipmentStatus.pending.key;

  // Action Logs audit trail dialog auditTrail
  return (
    <ItemPage
      addButtonLabel={LOGBOOK_LABEL.BUTTON.add_new_log}
      queryName="logSheetChangeByLogSheetEntryId"
      importFn={ImportHistoryOfLogSheet}
      CellsInfoArray={HistoryLogSheetCellsInfoArray}
      title={LOGBOOK_LABEL.action_logs_history_heading}
      dataTestId="log-sheet"
      type={formTypes.ACTION_LOG}
      fetchingFn={fetchLogSheets}
      mapFn={logSheetItemsToSheet}
      mapSecondFn={runSheetItemsToPDF}
      fileNamePrefix="action-logs-report"
      pageTitle={LOGBOOK_LABEL.PAGE_TITLE.log_books}
      orderBy="actionDate"
      //data for audit trails
      meta={inventoryId ? LogSheetTableEquipmentCentricMeta : LogSheetTableMeta}
      emptyItem={emptyLogSheet}
      cleanItemFn={makeCleanLogSheet}
      createItemChangeFn={CreateLogSheetChange}
      validationSchemaFactory={logSheetValidationSchemaFactory}
      selectSuggestionFn={logSheetSelectSuggestion}
      clearSuggestionFn={logSheetClearSuggestion}
      showChipBox={true}
      addNewDialogButtonLabel={LOG_TYPES.ADD_ACTION_LOG}
      equipmentDetail={equipmentDetail}
    >
      <ActionDataInputsBox
        isPropagationDisabled={isPropagationDisabled}
        defaultValues={defaultValues}
      />
    </ItemPage>
  );
};

export default LogSheetPage;
